import { Link } from "react-router-dom";
import { Home as HomeIcon } from "lucide-react";

export default function NotFound() {
  return (
    <div className="max-w-2xl mx-auto px-6 py-32 text-center" data-testid="not-found-page">
      <div className="overline mb-4">404</div>
      <h1 className="font-heading text-6xl text-[#484848]">Page not found</h1>
      <p className="mt-4 text-[#484848]/70">The page you&apos;re looking for has moved or doesn&apos;t exist.</p>
      <Link to="/" className="btn-primary mt-8 inline-flex">
        <HomeIcon className="w-4 h-4" /> Back home
      </Link>
    </div>
  );
}
